import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import css from './ServiceDropdown.css';
import useStarfishAPI from 'hooks/useStarfishAPI';
import useError from 'hooks/useError';
import Select from 'react-select';

function ServiceDropdown(props) {
  const [{ data, success, error }, callAPI] = useStarfishAPI();

  const serviceAdapter = (service) => ({
    id: service.serviceId,
    name: service.name,
    kioskType: service.kioskType
  });

  // All available services are selected by default
  const getDefaultServices = () => data.services.map(service => serviceAdapter(service));

  useEffect(() => {
    const URL = `../serviceCatalog/getWaitingRoomServices.html`;
    callAPI(URL, { method: 'GET' });
  }, []);

  // On success, set default services id as selected
  useEffect(() => {
    if ( success ) props.setServices(getDefaultServices());
  }, [success])

  useError(error, props.setError);

  const getOptions = () => data.services.map(service => ({label: service.name, value: service.serviceId}));

  const getSelectedOptions = () => getOptions().filter(({value}) => props.services
	  .map(service => service.id).indexOf(value) > -1);

  const getContent = () => {
    if ( !data.services || data.services.length === 0 ) return null;
    return (
      <Select
        aria-label="Filter by service"
        className={css['select']}
        options={getOptions()}
        isMulti
        isClearable
        isSearchable={false}
        theme={theme => ({
          ...theme,
          colors: {
          ...theme.colors,
            primary: '#E6A688',
            neutral20: "#57595B",
          },
        })}
        value={getSelectedOptions()}
        onChange={options => props.setServices(
          options.map(option => serviceAdapter(data.services.find(service => service.serviceId === option.value)))
        )}
      />
    );
  }

  return (
    <div className={css['container']}>
      <label>Filter by Service:</label>
      {getContent()}
    </div>
  )
}

ServiceDropdown.propTypes = {
  services: PropTypes.array,
  setServices: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

export default ServiceDropdown;
